

import React, { useState, useContext } from 'react'; 
import UserContext  from '../../context/Globales/UserContext';
import PropTypes from 'prop-types'
import clsx from 'clsx';

import {v4 as uuid } from 'uuid';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    Box,
    Button,
    Card,
    Carheader,
    Chip,
    Divider, 
    Table,
    TableBody,
    TableCell,

    TableRow,
    TableSortLabel, //
    Tooltip,
    makeStyles,
    CardHeader,
    TableHead,
    TableContainer,
} from '@material-ui/core';




const useStyles = makeStyles((theme) => ({
    root: {},
    actions: {
      justifyContent: 'flex-end'
    }, 
    FondoTable :{
        backgroundColor: theme.palette.greyFondo.main
    },
    containerTable: {
        maxHeight: 290,
        
      },

  }));
export const TblOrdenesnoPagoModal = ({className, rest}) => {
    const { datoICMODAL } = useContext(UserContext);
    const classes = useStyles();
    const [resultOrdePago] = useState(datoICMODAL.DetallesOrdenesNoPago?.OrdenesNoPago); 
    return(
        <Card
            className={clsx(classes.root, className)}
            {...rest}
            >
           {resultOrdePago ? 
          
            <TableContainer className={classes.containerTable}>

            <PerfectScrollbar>
                <Box >
                    <Table>
                        <TableHead className={classes.FondoTable}>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Banco</TableCell>
                                <TableCell>Número Cheque</TableCell>
                                <TableCell>Fecha Publicación</TableCell>
                                <TableCell>Motivo</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {resultOrdePago.map((datosOrdenPago, idbanco)=>(
                                <TableRow
                                hover
                                key={uuid()}>
                                    <TableCell>{idbanco + 1}</TableCell>
                                    <TableCell>{datosOrdenPago.Banco}</TableCell>
                                    <TableCell>{datosOrdenPago.NumeroDeCheques}</TableCell>
                                    <TableCell>{datosOrdenPago.FechaPublicacion}</TableCell>
                                    <TableCell>{datosOrdenPago.Motivo}</TableCell>
                                    
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>

            </PerfectScrollbar>
            </TableContainer>
            : ''}
            </Card>

    );
}
